module.exports = __webpack_public_path__ + "fonts/Manrope-600-latin-ext17.4e3c84a.woff2";